/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialFromJSON, FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialToJSON, } from './FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitial';
import { FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedFromJSON, FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedToJSON, } from './FxIdDomainSettingsAdvertisementFbInstantOptionsRewarded';
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementFbInstantOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementFbInstantOptions(value) {
    return true;
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementFbInstantOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Rewarded': json['Rewarded'] == null ? undefined : FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedFromJSON(json['Rewarded']),
        'Interstitial': json['Interstitial'] == null ? undefined : FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialFromJSON(json['Interstitial']),
    };
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementFbInstantOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementFbInstantOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Rewarded': FxIdDomainSettingsAdvertisementFbInstantOptionsRewardedToJSON(value['Rewarded']),
        'Interstitial': FxIdDomainSettingsAdvertisementFbInstantOptionsInterstitialToJSON(value['Interstitial']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementFbInstantOptions.js.map